<template>
  <el-table-column :label="label" :prop="prop" class-name="user-id" :sortable="sortable" />
</template>

<script>
export default {
  components: {
  },
  props: {
    label: {
      type: String,
      default: 'ユーザーID'
    },
    prop: {
      type: String,
      default: 'user_id'
    },
    sortable: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.el-table {
  th,
  td {
    &.user-id {
      width: 10em;
    }
  }
}
</style>
